import React from 'react';
import PageContentConstraint from './PageContentConstraint';

/**
 * Blocs rendus en racine de page sans enveloppe de largeur max (pleine largeur viewport).
 * - Heros / bandeaux explicites
 * - Sections proposal : fond pleine largeur, contenu contraint dans le composant
 *
 * Y entrer oblige le bloc à contraindre son propre contenu (gouttière +
 * largeur max), comme le fait `ProposalSection` : sans ça il traverserait la
 * page. C'est le prix du réglage « marge horizontale à 0 = pleine largeur ».
 */
export const PUCK_ROOT_FULL_BLEED_COMPONENTS = new Set([
  'ProposalSection',
  'TabsBlock',
]);

/**
 * Enveloppe chaque composant Puck racine dans {@link PageContentConstraint},
 * sauf ceux listés dans {@link PUCK_ROOT_FULL_BLEED_COMPONENTS}.
 */
export function withPageContentMaxWidth(components) {
  return Object.fromEntries(
    Object.entries(components).map(([name, def]) => {
      if (!def || typeof def.render !== 'function') return [name, def];
      if (PUCK_ROOT_FULL_BLEED_COMPONENTS.has(name)) return [name, def];
      const Original = def.render;
      return [
        name,
        {
          ...def,
          render: (props) => (
            <PageContentConstraint>
              <Original {...props} />
            </PageContentConstraint>
          ),
        },
      ];
    }),
  );
}
